import { GET_AUDIENCES } from "../actions/AudienceTypes";
const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
};
const initial = false;
function AudienceReducer(state = initialState, actions) {
  if (actions.type === GET_AUDIENCES) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (
    actions.type === "LOADING" &&
    actions.payload.action_model === GET_AUDIENCES
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { AudienceReducer };
